/* @ngInject */
const myRailwayModifPosition = (
  $timeout,
  utils,
  valueHandler,
  $$wagon,
  toaster,
  $$railway
) => {
  return {
    restrict: 'E',
    scope: {
      myWagons: '=',
      myRailway: '=',
    },
    template: require('./myRailwayModifPosition.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.utils = utils
      $scope.fieldsOptions = $$wagon.metadata.fields
      $scope.positions = {}

      $scope.$watch('myWagons', (newValue, oldValue) => {
        if (newValue !== oldValue && valueHandler.isArray(newValue)) {
          $scope.positions = {}
          for (let i = 0; i < $scope.myWagons.length; i++) {
            $scope.positions[$scope.myWagons[i].id] = $scope.myWagons[i].position
          }
        }
      })

      $scope.modifyPosition = async (_positions, _railwayId) => {
        try {
          const message = await $$wagon.request.modifyPosition(_positions, _railwayId)
          toaster.message(message)

          const railwayPromise = $$railway.request.getById(_railwayId)
          const wagonsPromise = $$wagon.request.getByRailway(_railwayId)

          try {
            $scope.myRailway = await railwayPromise
            $scope.myWagons = await wagonsPromise
          } catch (error) {
            toaster.error(error)
          }
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.isOk = true

      const sortNumber = (a, b) => {
        return a - b
      }

      $scope.$watch('positions', (newValue, oldValue) => {
        if (newValue !== oldValue && valueHandler.exists(newValue)) {
          $scope.isPositionsOk($scope.positions)
        }
      }, true)

      $scope.isPositionsOk = (_positions) => {
        $timeout(() => {
          const pos = []
          for (const wagonId in _positions) {
            if (!valueHandler.isEmpty(_positions[wagonId])) {
              pos.push(_positions[wagonId])
            }
          }
          pos.sort(sortNumber)

          for (let i = 0; i < pos.length; i++) {
            if (+pos[i] !== (i + 1)) {
              if (+pos[i] === i) {
                $scope.helpMessage = 'La position ' + (i) + ' est présente plusieurs fois'
              } else {
                $scope.helpMessage = 'La position ' + (i + 1) + ' est manquante'
              }
              $scope.isOk = false
              return false
            }
          }
          if (pos.length < $scope.myWagons.length) {
            $scope.helpMessage = 'La position ' + (pos.length + 1) + ' est manquante'
            $scope.isOk = false
            return false
          }
          $scope.helpMessage = ''
          $scope.isOk = true
          return true
        })
      }

      $scope.reversePosition = (_positions) => {
        $timeout(() => {
          const l = $scope.myWagons.length
          for (const wagonId in _positions) {
            _positions[wagonId] = l - (_positions[wagonId] - 1)
          }
        })
      }

      $scope.reverse = false
      $scope.propertyName = 'position'
      $scope.sortBy = (_propertyName) => {
        $scope.reverse = ($scope.propertyName === _propertyName) ? !$scope.reverse : false
        $scope.propertyName = _propertyName
      }
    },

    link: (scope, element, attrs) => {

    },
  }
}

export default myRailwayModifPosition



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/directives/edit/myRailwayModifPosition.js